var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('input',{staticClass:"el-input__inner",attrs:{"type":"text","disabled":""}}),_c('div',{attrs:{"id":_vm.uid,"name":"content"}})])}
var staticRenderFns = []

export { render, staticRenderFns }